import { IGuideFilterOptions } from './interfaces'
import { ISelectedGuests } from 'utils/reservation'

export const APP_NAME = 'Japan Wonder Travel'

export const HEADER_HEIGHT = 120
export const MOBILE_HEADER_HEIGHT = 80
export const SCROLLING_HEADER_HEIGHT = 86
export const FOOTER_HEIGHT = 74
export const HAS_FIXED_FOOTER_CLASS = 'has-fixed-footer'
export const TOPPAGE_HEADER_HEIGHT = 100
export const TOPPAGE_FOOTER_HEIGHT = 120
export const BREAKPOINT_DESKTOP_XXL = 1439
export const BREAKPOINT_DESKTOP_XL = 1279
export const BREAKPOINT_DESKTOP_LARGE = 1199
export const BREAKPOINT_DESKTOP = 1088
export const BREAKPOINT_TABLET_LARGE = 960
export const BREAKPOINT_TABLET = 767
export const BREAKPOINT_TABLET_SMALL = 720
export const BREAKPOINT_TABLET_MOBILE = 600
// text入力の既定文字数上限。Railsのstringカラム(varchar 255)に合わせる
export const MAX_TEXT_COUNT = 255
export const MAX_TEXTAREA_COUNT = 5000
export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_DISPLAY_FORMAT = 'YYYY/M/D'
export const DEFAULT_SEARCH_FILTER_GUESTS: ISelectedGuests = {
  adults: 1,
  children: 0,
  infants: 0,
} as const
export const DAYS_OF_THE_WEEK = ['日', '月', '火', '水', '木', '金', '土']
export const WEEK_DAYS_OPTIONS = Array.from({ length: 7 }, (_, i) => ({
  id: i,
  name: DAYS_OF_THE_WEEK[i],
}))
export const CONFIRMATION_DUE_DATE = 10
export const INQUIRY_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSehVtY3h32vM0pyAMHq6vxkvw6UoHuzKuHwyIEW1WaiZvEA1A/viewform'
export const DMC_LINK = 'https://japanwondertravel.com/dmc'

const paymentRequiredEl = document.getElementById('payment-required')
export const PAYMENT_REQUIRED = paymentRequiredEl
  ? paymentRequiredEl.getAttribute('data').toLowerCase() === 'true'
  : false

const rewardfuEl = document.getElementById('rewardful')
export const REWARDFUL_ID = rewardfuEl ? rewardfuEl.getAttribute('data') : ''

const assetHost = document.getElementById('asset_host')
export const ASSET_HOST = assetHost ? assetHost.getAttribute('data') : ''

export const TIME_OPTIONS = [
  { id: 0, name: 'AM:-' },
  { id: 1, name: 'AM:○' },
  { id: 2, name: 'AM:△' },
  { id: 3, name: 'AM:×' },
  { id: 10, name: 'PM:-' },
  { id: 4, name: 'PM:○' },
  { id: 5, name: 'PM:△' },
  { id: 6, name: 'PM:×' },
]

export const START_TIMES = [
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
  '24:00',
]

export const DAYS = [
  {
    value: 1,
    name: 'Sun',
  },
  {
    value: 2,
    name: 'Mon',
  },
  {
    value: 3,
    name: 'Tue',
  },
  {
    value: 4,
    name: 'Wed',
  },
  {
    value: 5,
    name: 'Thu',
  },
  {
    value: 6,
    name: 'Fri',
  },
  {
    value: 7,
    name: 'Sat',
  },
]

export const HOURS = [
  '01:00',
  '02:00',
  '03:00',
  '04:00',
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
  '24:00',
]

export const USER_TYPES = [
  { label: 'Admin', key: 'admin' },
  { label: 'Guest', key: 'guest' },
  { label: 'Guide', key: 'guide' },
  { label: 'Agent', key: 'agent' },
]
export const GUIDE_CALENDAR_MARK = {
  available: {
    label: '○',
  },
  maybe: {
    label: '△',
  },
  blocked: {
    label: 'x',
  },
  none: {
    label: '-',
  },
}

export const COLORS = {
  primary: '#00896C',
  secondary: '#4DAC98',
  tertiary: '#9DBFAF',
  success: '#49AE4C',
  successText: '#308532',
  successBG: '#DBEFDB',
  useally: '#F9C43B',
  useallyText: '#CA991C',
  useallyBG: '#FEF3D8',
  caution: '#E23B4F',
  cautionText: '#BA3B4A',
  cautionBG: '#F9D8DC',
  info: '#3DAABB',
  infoText: '#33808C',
  infoBG: '#D8EEF1',
  infoBorder: '#B3D6DB',
  subText: '#707C97',
  textLink: '#3273DC',
  black: '#212529',
  white: '#FFFFFF',
  background: '#F8F8F8',
  cardBG: '#F3F6F6',
  divider: '#BFC1C7',
  divider2: '#DCDEE4',
  lightGray: '#F1F1F1',
  disabled: '#CBCDD3',
  cardShadow: '0px 0px 1rem rgba(0, 0, 0, 0.15)',
  floatShadow: '0px 0px 2rem rgba(0, 0, 0, 0.15)',
  modalBackground: 'rgba(191, 193, 199, 0.8)',
  blackOverray: 'rgba(0, 0, 0, 0.3)',
  tooltipBG: 'rgba(0, 0, 0, 0.75)',
  alert: '#6B39F9',
  alertBG: '#E5E7F3',
  info2: '#3B53C7',
  infoBG2: '#EBEDF9',
  infoBorder2: '#BFC6ED',
  info3: '#F08A0D',
  infoBG3: '#FFF2C6',
  infoBorder3: '#F0D8A6',
  info4: '#f4a13c',
  info5: '#9B3BC7',
  infoBG5: '#F3E5F3',
  infoBorder5: '#E5C6E5',
  danger: '#D85B5B',
  dangerBG: '#F3E5E5',
  dangerBorder: '#E5C6C6',
  background2: '#F5F5F5',
  successBG2: '#E5F3F0',
  successBorder2: '#ACD9CF',
  paleGreen: '#ACD9CF',
  paleOrange: '#F0D8A6',
  paleBlue: '#BFC6ED',
  paleRed: '#E5C6C6',
  gray: '#CBCDD3',
  tourGuideMissingBG: '#FEE2E2',
  tourGuideSoundoutBG: '#FFE8CC',
  privateTourConnectedBG: '#FFFEB6',
  privateTourGuideAndGuestBG: '#CADDFC',
  tourGuideSoundoutText: '#D87A06',
}
export const SOUNDOUTED_STATUSES = ['agent_pre_requested', 'guide_approved', 'guide_declined']
// 打診〜正式依頼中(未アサイン)のステータス。依頼先ツアーグループの指定が意味を持つ状態
export const REQUESTING_STATUSES = [
  'agent_pre_requested',
  'guide_approved',
  'agent_official_requested',
]
export const REQUESTED_STATUSES = ['requested', 'cancled']
// ツアー作成時の交通費(post_cost.default_travel_cost)の既定値
export const DEFAULT_TRAVEL_COST = 1400
// ツアーの所要時間(時間)の選択肢。0.5h刻みで24hまで + 48h/72h
export const POST_DURATIONS = [...Array.from({ length: 48 }, (_, index) => (index + 1) / 2), 48, 72]

export const SKILL_LEVELS = {
  '1': 'NG',
  '2': '▲',
  '3': '△',
  '4': '◯',
  '5': '☆',
}

export const SKILL_CONDITION_TYPES = {
  gte: '以上',
  lte: '以下',
  exact: 'のみ',
}

export const SKILL_LEVEL_OPTIONS = [
  { id: '1', label: 'NG', value: '1' },
  { id: '2', label: '▲', value: '2' },
  { id: '3', label: '△', value: '3' },
  { id: '4', label: '◯', value: '4' },
  { id: '5', label: '☆', value: '5' },
]

export const JOB_STATUS_LABELS = {
  open: '募集中',
  upcoming: '募集予定',
  ended: '募集終了',
}

export const JOB_SKILL_LEVEL_MIN = Math.min(...Object.keys(SKILL_LEVELS).map(Number)) + 1
export const JOB_SKILL_LEVEL_MAX = Math.max(...Object.keys(SKILL_LEVELS).map(Number))

export const GUIDE_STATUSES = ['active', 'inactive', 'deleted'] as const

export const DEFAULT_GUIDE_FILTER_OPTIONS: IGuideFilterOptions = {
  name: '',
  email: '',
  tel: '',
  ages: [],
  gender: '',
  tour_guide_count_min: null,
  tour_guide_count_max: null,
  agent_skills: [],
  agent_ranks: [],
  assign_guide_tour_skills: [{ tour_skill_id: '', level: '', condition_type: 'gte' }],
  statuses: ['active'],
  login_status: '',
}
